import {InjectionToken} from '@angular/core';
import {EventExecutedSuccessfullyUpdate} from '@domain/event-executed-successfully-update';
import {Observable} from 'rxjs';

export const SIGNALR_EVENT = new InjectionToken<SignalrEvent>('SignalrEvent');

export interface SignalrEvent {
  getEventExecutedSuccessfullyUpdates(): Observable<EventExecutedSuccessfullyUpdate>;
}
